import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PrintViewTakemoney from "./PrintViewTakemoney";
import { change_Lang } from "../../../actions/Helper_action";
import { View_Take_Money } from "../../../actions/Invoice_action";

export class Print_ViewTakemoney extends Component {
 componentDidMount() {
  this.props.View_Take_Money(
   this.props.match.params.id,
   this.props.match.params.index
  );
 }
 render() {
  const {
   take_money_view,
   lang,
   change_Lang,
   View_Take_Money,
   index_takemoney,
   user,
  } = this.props;
  return (
   <Fragment>
    <div className="container-fluid">
     <PrintViewTakemoney
      take_money_view={take_money_view}
      lang={lang}
      change_Lang={change_Lang}
      View_Take_Money={View_Take_Money}
      index_takemoney={this.props.match.params.index}
      user={user}
     />
    </div>
   </Fragment>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  take_money_view: state.Invoice_Reducer.take_money_view,
  list_of_take_money: state.Invoice_Reducer.list_of_take_money,
  index_takemoney: state.Invoice_Reducer.index_takemoney,
  user: state.AuthReducer.user,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
  View_Take_Money: (id, index) => dispatch(View_Take_Money(id, index)),
 };
};

export default connect(
 mapStateToProps,
 mapDispatchToProps
)(Print_ViewTakemoney);
